"use client";
import React, { useState, useEffect } from 'react';

const generateCode = () => {
  let code = '';
  for (let i = 0; i < 4; i++) {
    code += Math.floor(Math.random() * 10).toString();
  }
  return code;
};

const CyberHacker = () => {
  const [targetCode, setTargetCode] = useState(generateCode());
  const [guesses, setGuesses] = useState([]);
  const [currentGuess, setCurrentGuess] = useState('');
  const [gameOver, setGameOver] = useState(false);
  const [win, setWin] = useState(false);

  const maxAttempts = 6;

  const handleKeyPress = (e) => {
    if (gameOver) return;
    if (e.key === 'Enter') {
      submitGuess();
    }
  };

  const submitGuess = () => {
    if (currentGuess.length !== 4 || gameOver) return;
    
    // Evaluate guess
    const feedback = [];
    let targetArr = targetCode.split('');
    let guessArr = currentGuess.split('');

    // Check exact matches (Green)
    for (let i = 0; i < 4; i++) {
      if (guessArr[i] === targetArr[i]) {
        feedback[i] = 'green';
        targetArr[i] = null;
        guessArr[i] = null;
      }
    }

    // Check partial matches (Yellow)
    for (let i = 0; i < 4; i++) {
      if (guessArr[i] && targetArr.includes(guessArr[i])) {
        feedback[i] = 'yellow';
        targetArr[targetArr.indexOf(guessArr[i])] = null;
      } else if (guessArr[i]) {
        feedback[i] = 'gray';
      }
    }

    const newGuesses = [...guesses, { guess: currentGuess, feedback }];
    setGuesses(newGuesses);
    setCurrentGuess('');

    if (currentGuess === targetCode) {
      setWin(true);
      setGameOver(true);
    } else if (newGuesses.length >= maxAttempts) {
      setGameOver(true);
    }
  };

  const resetGame = () => {
    setTargetCode(generateCode());
    setGuesses([]);
    setCurrentGuess('');
    setGameOver(false);
    setWin(false);
  };

  return (
    <div className="w-full bg-brand-surface border border-gray-300 rounded p-6 font-mono text-brand-text shadow-sm">
      <div className="flex justify-between items-center border-b border-brand-border pb-3 mb-4">
        <h2 className="text-xl font-bold tracking-widest uppercase">&gt;_ SYS_BREACH</h2>
        <span className="text-xs uppercase text-brand-muted">v2.0.4</span>
      </div>
      
      <p className="text-sm mb-4 text-brand-muted">Target acquired. Bypass mainframe using 4-digit passcode. You have {maxAttempts - guesses.length} attempts left.</p>

      <div className="space-y-2 mb-6">
        {guesses.map((g, idx) => (
          <div key={idx} className="flex gap-2">
            {g.guess.split('').map((char, i) => (
              <div 
                key={i} 
                className={`w-10 h-10 flex items-center justify-center text-lg font-bold border 
                  ${g.feedback[i] === 'green' ? 'bg-brand-secondary text-brand-text-inverse border-gray-900' : 
                    g.feedback[i] === 'yellow' ? 'bg-gray-400 text-brand-text-inverse border-gray-400' : 
                    'bg-brand-surface-alt text-brand-muted border-brand-border'}`}
              >
                {char}
              </div>
            ))}
          </div>
        ))}
        {/* Empty slots for remaining guesses */}
        {Array.from({ length: Math.max(0, maxAttempts - guesses.length) }).map((_, idx) => (
          <div key={`empty-${idx}`} className="flex gap-2 opacity-50">
            {[0, 1, 2, 3].map(i => (
              <div key={i} className="w-10 h-10 border border-gray-300 bg-brand-surface-alt"></div>
            ))}
          </div>
        ))}
      </div>

      {!gameOver ? (
        <div className="flex gap-2">
          <span className="text-xl">&gt;</span>
          <input 
            type="text" 
            maxLength={4} 
            value={currentGuess} 
            onChange={(e) => setCurrentGuess(e.target.value.replace(/\D/g, ''))}
            onKeyDown={handleKeyPress}
            className="bg-transparent border-none outline-none text-xl w-32 tracking-[0.5em] text-brand-text placeholder-gray-300"
            placeholder="____"
          />
          <button 
            onClick={submitGuess}
            disabled={currentGuess.length !== 4}
            className="ml-auto px-4 py-1 border border-gray-900 text-brand-text hover:bg-[var(--brand-surface-hover)] hover:text-white transition-colors disabled:opacity-30 uppercase text-sm font-bold"
          >
            Execute
          </button>
        </div>
      ) : (
        <div className="mt-6 p-4 border border-dashed border-gray-400 bg-brand-surface-alt text-center">
          {win ? (
            <p className="text-xl font-bold text-brand-text mb-2">ACCESS GRANTED</p>
          ) : (
            <div>
              <p className="text-xl font-bold text-brand-text mb-2">ACCESS DENIED</p>
              <p className="text-sm text-brand-muted mb-2">Passcode was: {targetCode}</p>
            </div>
          )}
          <button onClick={resetGame} className="mt-4 px-6 py-2 bg-brand-secondary text-brand-text-inverse font-bold uppercase tracking-widest hover:bg-[var(--brand-surface-hover)] transition-colors">
            Reboot System
          </button>
        </div>
      )}
    </div>
  );
};

export default CyberHacker;
